"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
var _category = require("@/api/category");
var _storage = require("@/api/storage");
var _auth = require("@/utils/auth");
var _MultiLanguageInp = _interopRequireDefault(require("@/components/MultiLanguageInp"));
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MallCategory',
  components: {
    MultiLanguageInp: _MultiLanguageInp.default
  },
  data: function data() {
    var checkNum = function checkNum(rule, value, callback) {
      if (!value) {
        return callback(new Error('输入类目编码，且大于100000'));
      } else if (value <= 100000) {
        return callback(new Error('类目编码大于100000'));
      } else {
        callback();
      }
    };
    return {
      multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
      uploadPath: _storage.uploadPath,
      list: [],
      listLoading: true,
      catL1: [],
      cart2: [],
      dataForm: {
        id: undefined,
        code: '',
        productType: null,
        name: '',
        keywords: '',
        level: 'L2',
        pid: '',
        pidL2: '',
        pidL3: '',
        desc: '',
        iconUrl: '',
        picUrl: '',
        isSupportColor: '',
        isSupportSize: ''
      },
      dialogFormVisible: false,
      editDialogVisible: false,
      dialogStatus: '',
      templateList: [],
      categoryId: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      required: {
        required: true,
        message: '类目名不能为空',
        trigger: 'blur'
      },
      rules: {
        name: [],
        pidL2: [{
          required: true,
          message: '父类目不能为空',
          trigger: 'blur'
        }],
        pidL3: [{
          required: true,
          message: '父类目不能为空',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '编码不能为空',
          trigger: 'blur'
        }],
        productType: [{
          required: true,
          validator: checkNum,
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    headers: function headers() {
      return {
        'Mu-Token': (0, _auth.getToken)()
      };
    }
  },
  mounted: function mounted() {
    console.log((0, _auth.getToken)(), ' getToken()');
    this.rules.name = [this.required];
  },
  created: function created() {
    this.getList();
    this.getCatL1();
    this.getCatL2();
  },
  methods: {
    setPid: function setPid(list) {
      var _this = this;
      var parentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      list.forEach(function (item) {
        item.pid = parentId;
        if (item.children && item.children.length > 0) {
          _this.setPid(item.children, item.id);
        }
      });
      return list;
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _category.listCategory)().then(function (response) {
        _this2.list = _this2.setPid(response.data.data.list);
        _this2.listLoading = false;
      }).catch(function () {
        _this2.list = [];
        _this2.listLoading = false;
      });
    },
    getCatL1: function getCatL1() {
      var _this3 = this;
      (0, _category.listCatL1)().then(function (response) {
        _this3.catL1 = response.data.data.list;
        console.log(_this3.catL1, ' this.catL1');
      });
    },
    getCatL2: function getCatL2() {
      var _this4 = this;
      (0, _category.listCatL2)().then(function (response) {
        _this4.catL2 = response.data.data.list;
        console.log(_this4.catL2, ' this.catL2');
      });
    },
    resetForm: function resetForm() {
      this.dataForm = {
        id: undefined,
        name: '',
        keywords: '',
        level: 'L2',
        pid: '',
        pidL2: '',
        pidL3: '',
        desc: '',
        iconUrl: '',
        picUrl: '',
        isSupportColor: true,
        isSupportSize: true
      };
    },
    onLevelChange: function onLevelChange(value) {
      if (value === 'L1') {
        this.dataForm.pid = 0;
        this.dataForm.pidL2 = '';
        this.dataForm.pidL3 = '';
      }
      if (value === 'L2') {
        this.dataForm.pid = '';
        this.dataForm.pidL3 = '';
      }
      if (value === 'L3') {
        this.dataForm.pid = '';
        this.dataForm.pidL2 = '';
        // this.dataForm.pidL3 = ''
      }
    },
    handleCreate: function handleCreate() {
      var _this5 = this;
      this.resetForm();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        _this5.$refs['dataForm'].clearValidate();
      });
    },
    uploadIconUrl: function uploadIconUrl(response) {
      this.dataForm.iconUrl = response.data.url;
    },
    uploadPicUrl: function uploadPicUrl(response) {
      this.dataForm.picUrl = response.data.url;
    },
    createData: function createData() {
      var _this6 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this6.dataForm.level == 'L2') {
            _this6.dataForm.pid = _this6.dataForm.pidL2;
          } else if (_this6.dataForm.level == 'L3') {
            _this6.dataForm.pid = _this6.dataForm.pidL3;
          }
          (0, _category.createCategory)(_this6.dataForm).then(function (response) {
            _this6.getList();
            // 更新L1目录
            _this6.getCatL1();
            _this6.getCatL2();
            _this6.dialogFormVisible = false;
            _this6.$notify.success({
              title: '成功',
              message: '创建成功'
            });
          }).catch(function (response) {
            _this6.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    },
    handleUpdate: function handleUpdate(row) {
      var _this7 = this;
      this.dataForm = Object.assign({}, row);
      if (this.dataForm.level === 'L2') {
        this.$set(this.dataForm, 'pidL2', row.pid * 1);
      } else if (this.dataForm.level === 'L3') {
        this.$set(this.dataForm, 'pidL3', row.pid * 1);
      }
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(function () {
        _this7.$refs['dataForm'].clearValidate();
      });
    },
    // 编辑模板
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(row) {
        var res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _category.listPropByCid)({
                cid: row.id
              });
            case 1:
              res = _context.v;
              this.categoryId = row.id;
              this.templateList = res.data.data;
              // 如果之前没有生成过则自动插入一条
              if (!this.templateList.length) {
                this.templateList.push({
                  uniId: Date.now().toString(36),
                  name: ''
                });
              }
              // unid作为遍历模板的唯一值
              this.templateList = this.templateList.map(function (item) {
                if (item.id) {
                  item.unid = item.id;
                }
                return item;
              });
              this.editDialogVisible = true;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    updateData: function updateData() {
      var _this8 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this8.dataForm.level === 'L2') {
            _this8.dataForm.pid = _this8.dataForm.pidL2;
          } else if (_this8.dataForm.level === 'L3') {
            _this8.dataForm.pid = _this8.dataForm.pidL3;
          }
          (0, _category.updateCategory)(_this8.dataForm).then(function () {
            _this8.getList();
            // 更新L1目录
            _this8.getCatL1();
            _this8.getCatL2();
            _this8.dialogFormVisible = false;
            _this8.$notify.success({
              title: '成功',
              message: '更新成功'
            });
          }).catch(function (response) {
            _this8.$notify.error({
              title: '失败',
              message: response.data.errmsg
            });
          });
        }
      });
    },
    handleDelete: function handleDelete(row) {
      var _this9 = this;
      this.$confirm('是否要进行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _category.deleteCategory)(row).then(function (response) {
          _this9.getList();
          // 更新L1目录
          _this9.getCatL1();
          _this9.getCatL2();
          _this9.$notify.success({
            title: '成功',
            message: '删除成功'
          });
        }).catch(function (response) {
          _this9.$notify.error({
            title: '失败',
            message: response.data.errmsg
          });
        });
      });
    },
    // 删除一条模板
    handleDeleteTemplate: function handleDeleteTemplate(index) {
      this.templateList.splice(index, 1);
    },
    // 插入一条模板
    handleAddTemplate: function handleAddTemplate() {
      this.templateList.push({
        uniId: Date.now().toString(36),
        name: ''
      });
    },
    // 对数据统一保存
    handleSave: function () {
      var _handleSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var _this0 = this;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.templateList.forEach(function (item, index) {
                item.categoryId = _this0.categoryId;
                // 如果未输入数据则不进行保存
                if (!item.name) {
                  _this0.templateList.splice(index, 1);
                }
              });
              _context2.n = 1;
              return (0, _category.editTemplate)(this.templateList);
            case 1:
              this.editDialogVisible = false;
              this.templateList = [];
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }(),
    onEnable: function onEnable(val, value) {
      var data = {
        id: value.id,
        isEnable: val
      };
      (0, _category.enableCategory)(data).then(function (res) {
        // this.getList()
      });
    },
    chaneSizeVal: function chaneSizeVal() {
      var _this1 = this;
      this.$nextTick(function () {
        _this1.dataForm.isSupportSize ? _this1.$set(_this1.dataForm, 'isSupportSize', '') : _this1.$set(_this1.dataForm, 'isSupportSize', true);
      });
    }
  }
};